import { Trans } from '@lingui/react/macro';
import { AnimatedList, NoddiBasicCard, NoddiDummyButton, TablePagination } from 'noddi-ui-web';
import { getCommonTranslations } from '../../utils/commonTranslations';

type Item = {
  id: number;
  /** Label the caller already has, such as Home. The booking-valid address has no label. */
  title?: string;
  addressName: string;
};

type Pagination = {
  pageIndex: number;
  pageSize: number;
};

type Props = {
  items: readonly Item[];
  onSelect: (id: number) => void;
  pagination?: {
    pagination: Pagination;
    loading: boolean;
    totalCount: number;
    onChange: (pagination: Pagination) => void;
  };
};

export const SavedAddressList = ({ items, onSelect, pagination }: Props) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className='flex flex-col gap-3'>
      <span className='font-semibold text-primary'>
        <Trans>Saved addresses</Trans>
      </span>
      <AnimatedList delayBetweenItems={75} className='flex flex-col gap-3'>
        {items.map((item) => (
          <NoddiBasicCard
            key={item.id}
            onClick={() => onSelect(item.id)}
            size='small'
            className='flex items-center justify-between gap-4'
          >
            <div className='flex flex-col'>
              {item.title && <span className='font-semibold'>{item.title}</span>}
              <span className={item.title ? 'text-sm text-muted-foreground' : undefined}>{item.addressName}</span>
            </div>
            <NoddiDummyButton endIcon='ArrowRight' variant='outline' size='small'>
              <Trans>Choose</Trans>
            </NoddiDummyButton>
          </NoddiBasicCard>
        ))}
      </AnimatedList>
      {pagination && pagination.totalCount > pagination.pagination.pageSize && (
        <NoddiBasicCard size='small'>
          <TablePagination
            pagination={pagination.pagination}
            loading={pagination.loading}
            totalCount={pagination.totalCount}
            onChange={pagination.onChange}
            translations={getCommonTranslations().table}
          />
        </NoddiBasicCard>
      )}
    </div>
  );
};
